// extracted by mini-css-extract-plugin
export default {"showMore":"RepaymentsSchedule_showMore"};